import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FcLocationsInputModule } from '@core/components/fc-input/search-many/fc-locations-input/fc-locations-input.module';
import { EquipmentsTypeComponentModule } from '@core/components/inputs/equipments-type/equipments-type.module';
import { CompanyLegacyModule } from '@core/components/legacy-input/search-one/company/company.module';
import { LocationLegacyModule } from '@core/components/legacy-input/search-one/location/location.module';
import { MaintenanceTypeLegacyModule } from '@core/components/legacy-input/search-one/maintenance-type/maintenance-type.module';
import { SegmentLegacyModule } from '@core/components/legacy-input/search-one/segment/segment.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { FilterRecurrencesComponent } from './filter-recurrences.component';

@NgModule({
  declarations: [
    FilterRecurrencesComponent
  ],
  imports: [
    MatDividerModule,
    MatListModule,
    MatSlideToggleModule,
    FuseSharedModule,
    TranslateModule,
    MatIconModule,
    MatRippleModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatToolbarModule,
    MatSelectModule,
    LocationLegacyModule,
    SegmentLegacyModule,
    EquipmentsTypeComponentModule,
    MaintenanceTypeLegacyModule,
    CompanyLegacyModule,
    FcLocationsInputModule
  ],
  exports: [
    FilterRecurrencesComponent
  ]
})
export class FilterRecurrencesModule { }
